import { JOB_LIST } from '../../../constants';

const initialState = {
  data: {},
  loading: true,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case JOB_LIST.LOAD:
      return {
        ...state,
        loading: true
      };
    case JOB_LIST.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case JOB_LIST.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
